module.exports = __webpack_public_path__ + "static/media/Burcum Turkmen.13022da0.png";